import * as Sentry from "@sentry/react";

export function reportErrorToSentry(error: string | Error, category: string, subCategory?: string) {
  Sentry.withScope((scope) => {
    scope.setTag("category", category);
    if (subCategory) {
      scope.setTag("subCategory", subCategory);
    }

    // -- Normalize error into an Error object --
    const err: Error = typeof error === "string" ? new Error(error) : error;
    err.name = category || err.name;

    // -- Capture the error --
    Sentry.captureException(err);
  });
}
